const data = [
  {
    id: 1,
    name: '首页',
    eng: 'home',
    slug: '/'
  },
  {
    id: 2,
    name: '概况',
    slug: '/about',
    eng: 'about us'
  },
  {
    id: 3,
    name: '资讯',
    slug: '/newsCenter/news',
    eng: 'news center'
  },
  {
    id: 4,
    name: '科技',
    slug: '/hitech',
    eng: 'hitech'
  },
  {
    id: 5,
    name: '城市',
    eng: 'city',
    slug: '/city'
  },
  {
    id: 6,
    name: '品牌',
    eng: 'brand',
    slug: '/brand'
  },
  {
    id: 7,
    name: '加入我们',
    eng: 'Join Us',
    slug: '/join'
  },
  {
    id: 8,
    name: '信息公开',
    eng: 'information DISCLOSURE',
    slug: '/information'
  }
]

export default data
